import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Button, Icons, TYPES } from 'sarsaparilla';
import SecurityHelper from '../../utils/security';
import { CurrentUserProps } from '../../props/currentUser';
import { logout, reload } from '../../actions/currentUser';
import { getCurrentUser } from '../../reducers/currentUser';
import { fullName } from '../../utils/strings';

import headerStyles from '../Header/Header.scss';
import styles from './AccountInfo.scss';

const propTypes = {
  history: TYPES.HISTORY,
  currentUser: CurrentUserProps,
  logout: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired
};

const defaultProps = {};

export class AccountInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showingPopover: false
    };
    this.anchorRef = null;

    this.togglePopover = this.togglePopover.bind(this);
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    if (SecurityHelper.isLoggedIn()) {
      this.props.reload(SecurityHelper.user());
    }
    document.addEventListener('click', this.handleClickOutsidePopover);
    document.addEventListener('keyup', this.handleEscapeKey);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutsidePopover);
    document.removeEventListener('keyup', this.handleEscapeKey);
  }

  logout() {
    this.props.logout()
      .then(() => this.props.history.push('/'));
  }

  togglePopover() {
    if (this.state.showingPopover) {
      this.dismissPopover();
    }
    else {
      this.showPopover();
    }
  }

  showPopover = () => {
    this.setState({ showingPopover: true });
  };

  dismissPopover = () => {
    this.setState({ showingPopover: false });
  };

  handleClickInsideAnchor = (e) => {
    e.preventDefault();
    this.togglePopover();
  };

  handleKeyDownInsideAnchor = (event) => {
    if (event.code === 'Space' || event.code === 'Enter' || event.which === '32' || event.which === '13') {
      event.preventDefault();
      this.togglePopover();
    }
  }

  handleClickInsidePopover = (e) => {
    e.preventDefault();
    this.dismissPopover();
  };

  handleKeyDownInsidePopover = (event) => {
    if (event.code === 'Space' || event.code === 'Enter' || event.which === '32' || event.which === '13') {
      event.preventDefault();
      this.dismissPopover();
    }
  }

  handleClickOutsidePopover = (e) => {
    if (!this.state.showingPopover) {
      return;
    }

    if (e.target === this.anchorRef || e.target.parentNode === this.anchorRef) {
      // If the anchor node was clicked, then ignore it since it is handled
      // by its own handler.
      return;
    }
    this.dismissPopover();
  };

  handleEscapeKey = (e) => {
    if (!this.state.showingPopover) {
      return;
    }

    const evt = e || window.event;
    let shouldDismiss = false;

    if ('key' in evt) {
      shouldDismiss = evt.key === 'Escape' || evt.key === 'Esc';
    }
    else {
      shouldDismiss = evt.keyCode === 27;
    }

    if (shouldDismiss) {
      this.dismissPopover();
    }
  };

  render() {
    const { currentUser: { account, apiKey: { adminAccess } } } = this.props;
    const loggedIn = SecurityHelper.isLoggedIn();

    if (!loggedIn) {
      return (
        <div>
          <Link activeClassName={headerStyles.active} to="/login">Sign in</Link>
        </div>
      );
    }

    /* eslint-disable brace-style */
    // TODO: The next line is only added to remove a lint error until we're ready to make this 508 compliant.
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <div
        tabIndex="0"
        role="button"
        className={styles['logged-in']}
        onKeyDown={this.handleKeyDownInsideAnchor}
        onClick={this.handleClickInsideAnchor}>
        <div className={styles.anchor} ref={(e) => { this.anchorRef = e; }}>
          <Icons.IconAccountCircle />
          <div>{fullName(account)}</div>
        </div>
        {
          this.state.showingPopover &&
          <div
            tabIndex="0"
            role="button"
            className={styles.popover}
            onKeyDown={this.handleKeyDownInsidePopover}
            onClick={this.handleClickInsidePopover}>
            <span className="rec-sr-only">Account Info</span>
            <ul>
              <li>
                <Link to="/profile">Profile</Link>
              </li>
              {adminAccess && (
                <li>
                  <Link to="/admin">Admin Users</Link>
                </li>
              )}
              <li>
                <Button appearance="link" onClick={this.logout}>Logout</Button>
              </li>
            </ul>
          </div>
        }
      </div>
    );
    /* eslint-enable jsx-a11y/no-static-element-interactions */
    /* eslint-enable brace-style */
  }
}

AccountInfo.propTypes = propTypes;
AccountInfo.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ logout, reload }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountInfo));
